import carousel from '../../../../design3/asset-build/js/custom/carousel';
import { getRTL } from '../../../../design3/asset-build/js/custom/_utils';

const isRTL = getRTL();

const componentName = 'PPCCarousel';
const selectors = {
	pagination: `.${componentName}-Pagination`,
	nextButton: `.${componentName}-nextButton`,
	prevButton: `.${componentName}-prevButton`,
};
export default function initCarousels() {
	const ppcCarousels = carousel(componentName, null, { fade: true });
	ppcCarousels.forEach(({ $carouselContainer, flickity }) => {
		flickity.on('change', function (i) {
			const index = i + 1;
			const $pagination = $carouselContainer.children(selectors.pagination);
			const paginationVal = `${index} ${isRTL ? '\\' : '/'} ${$pagination.data(
				'totalitemsdisplay'
			)}`;
			$pagination.children('span').text(paginationVal);
			const nextButton = $pagination.children(selectors.nextButton);
			const prevButton = $pagination.children(selectors.prevButton);
			nextButton.removeAttr('hidden');
			prevButton.removeAttr('hidden');
		});
		$carouselContainer.on('reset', () => {
			window.requestAnimationFrame(() => flickity.resize());
		});
	});
}
window.FS = window.FS || {};
window.FS.JOURNEY_AWARENESS = window.FS.JOURNEY_AWARENESS || {};
window.FS.JOURNEY_AWARENESS.initCarousels = initCarousels;
window.dispatchEvent(new Event('fsActionReady'));
